import i18n from "../../../plugins/i18n";
const language = localStorage.getItem("language")
i18n.locale = language ? language : "pt-br"

export default {

    reportData: [],
    reportAgreement: {
        index: 0,
        title: [
            i18n.t("store.report_state.title1"),
            i18n.t("store.report_state.title2"),
            i18n.t("store.report_state.title3")
        ],
        content: [
            [
                {
                    item: i18n.t("store.report_state.content1[0]")
                },
                {
                    item: i18n.t("store.report_state.content1[1]")
                },
                {
                    item: i18n.t("store.report_state.content1[2]")
                },
            ],
            [
                {
                    item: i18n.t("store.report_state.content2[0]")
                },
                {
                    item: i18n.t("store.report_state.content2[1]")
                },
                {
                    item: i18n.t("store.report_state.content2[2]")
                },
            ],
            [
                {
                    item: i18n.t("store.report_state.content3")
                }
            ]
        ],
    },
    reportFinish: ""
}